<!-- <ion-header>
  <ion-toolbar>
    <ion-title>Upload Data to the Server</ion-title>
  </ion-toolbar>
</ion-header> -->


<ion-content class="no-hover-page" [fullscreen]="true">
  <form [formGroup]="addTextForm" (ngSubmit)="onSubmit()" class="ion-padding" style="margin-top: 55px;">
    <ion-card class="form-card">
      <ion-card-content>
          <ion-item class="form-item">
            <ion-label position="stacked">Text</ion-label>
            <ion-input formControlName="message" placeholder="Enter your text"></ion-input>
          </ion-item>

          <ion-item class="form-item">
            <ion-label position="stacked">Sentiment</ion-label>
            <ion-select formControlName="sentiment" name="sentiment">
              <!-- <ion-select-option value="Positief">Positief</ion-select-option>
              <ion-select-option value="Negatief">Negatief</ion-select-option>
              <ion-select-option value="Neutraal">Neutraal</ion-select-option> -->
              <ion-select-option *ngFor="let option of sentimentOptions" [value]="option.value">
                {{ option.label }}
              </ion-select-option>
            </ion-select>
          </ion-item>
      </ion-card-content>
    </ion-card>

    
   
  </form>

    <div>
      <div>
        <h2 class="dialog-title" style="margin-left: 15px;">Is the Sentiment response correct? Do you want to add it to dataset?</h2>
        <!-- <button class="dialog-close-button">&times;</button> -->
        <div style="display: flex; justify-content: flex-end;margin-right: 15px;">
          <button style="margin: 10px;width: 100px;" class="button button-secondary" (click)="onCancel()">Cancel</button>
          <button style="margin: 10px; width: 100px;" class="button button-primary" (click)="onSubmit()">Yes</button>
        </div>
      </div>
    </div>
</ion-content>

<!-- <ion-content class="ion-padding" [fullscreen]="true">
  <form [formGroup]="addTextForm" (ngSubmit)="onSubmit()">
    
    <ion-item lines="none">
      <ion-input formControlName="message" placeholder="niet" readonly></ion-input>
    </ion-item>

    <ion-item lines="none">
      <ion-input formControlName="sentiment" placeholder="Neutraal"></ion-input>
    </ion-item>

    <div style="display: flex; justify-content: flex-end; margin-top: 20px;">
      <ion-button fill="clear" color="medium" (click)="dismiss()">CANCEL</ion-button>
      <ion-button type="submit">SAVE</ion-button>
    </div>

  </form>
</ion-content> -->